import type { FC } from "react";

import { HighlightCard as HighlightCardUI } from "@jti/ui/components/HighlightCard";

import type { highlightCardInputs } from "./HighlightCard.builder";

type HighlightCardBuilderProps = BuilderComponentProps<typeof highlightCardInputs>;

export const HighlightCard: FC<HighlightCardBuilderProps> = ({
  buttonText,
  description,
  imageUrl,
  title,
  linkUrl,
  theme,
  leftBadgeText,
  rightBadgeText,
  alt = "",
  imageSeoTitle,
  backgroundType,
  videoFileReference,
  trackingEvent,
  openIn,
}) => {
  return (
    <HighlightCardUI
      backgroundType={backgroundType}
      videoFileReference={videoFileReference}
      buttonText={buttonText}
      trackingEvent={trackingEvent}
      description={description}
      imageUrl={imageUrl}
      title={title}
      alt={alt}
      imageTitle={imageSeoTitle}
      linkUrl={linkUrl}
      theme={theme}
      leftBadgeText={leftBadgeText}
      rightBadgeText={rightBadgeText}
      openIn={openIn}
    />
  );
};
